import { render } from "./MessageListView.vue?vue&type=template&id=6e6841ec&scoped=true"
import script from "./MessageListView.vue?vue&type=script&lang=js"
export * from "./MessageListView.vue?vue&type=script&lang=js"

import "./MessageListView.vue?vue&type=style&index=0&id=6e6841ec&scoped=true&lang=css"

import exportComponent from "E:\\源码\\baoxiu\\baoxiu\\VUE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e6841ec"]])

export default __exports__